import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSocket } from "../../context/SocketContext";
import { setQuizLiveGame } from "../../slices/fun_stuff/quizAuthSlice";
import { Button, Card } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTowerBroadcast, faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';
import LiveGameRoom from "./LiveGameRoom";
import ChooseGroupModal from "./ChooseGroupModal";

const LiveGameBtn = (() => {
    const socket = useSocket();
    const dispatch = useDispatch();

    const { quizGroups, quizLiveGame } = useSelector((state) => state.quizAuth);

    const [showGroupModal, setShowGroupModal] = useState(false);
    const [groupId, setGroupId] = useState('');
    const [groupName, setGroupName] = useState('');

    const [showLiveGameRoom, setShowLiveGameRoom] = useState(false);
    const [liveGroupMembers, setLiveGroupMembers] = useState([]);

    const [currLiveGroups, setCurrLiveGroups] = useState([]);

    useEffect(() => {
        if (quizLiveGame?.groupId) {
            setGroupId(quizLiveGame.groupId);
            setGroupName(quizLiveGame.groupName);
            setShowLiveGameRoom(true);
        }
    }, [quizLiveGame]);

    useEffect(() => {
    if (quizGroups) {
        const liveGroups = quizGroups.filter((group) => group.live_game);
        setCurrLiveGroups(liveGroups);
    }
    }, [quizGroups]);

    function handleLiveGame(selectedGroup) {
        setGroupId(selectedGroup.id);
        setGroupName(selectedGroup.group_name);
        socket.emit('join_live_game_room', { groupId: selectedGroup.id, groupKey: selectedGroup.group_key }, res => {
            console.log('Game in action: ', res.quiz)
            setLiveGroupMembers(res.currentMembers);
            dispatch(setQuizLiveGame({ 
                participants: res.currentMembers,
                groupId: selectedGroup.id,
                groupName: selectedGroup.group_name,
                completed: false,
                groupReady: false,
                startActive: false,
                topicsRemaining: 0,
                paramsSubmitted: false,
                totalQuestions: 0,
                totalCorrect: 0,
                numCorrect: 0,
                numQuestions: 0,
                inAction: res.inAction,
                startActive: res.startActive,
            }));
        });

        setShowLiveGameRoom(true);
    }

    return (
        <Card className="mt-4 w-75">
            <Card.Body className="d-flex flex-column justify-content-center align-items-center">

                {currLiveGroups.length > 0 && 
                currLiveGroups.map((group) => (
                    <Button
                        key={`button-${group.id}`}
                        size="lg"
                        className="green-silver-btn mb-3"
                        onClick={() => {handleLiveGame(group)}}
                    >
                        <FontAwesomeIcon icon={faArrowRightToBracket} className="me-2"/>
                        {`Join live Game for ${group.group_name}`}
                    </Button>
                ))}

                <Button 
                    size="lg" 
                    className="green-silver-btn mb-0"
                    onClick={() => setShowGroupModal(true)}
                >
                    <FontAwesomeIcon icon={faTowerBroadcast} className="me-2"/>
                    Start Live Game
                </Button>

                {showGroupModal && 
                <ChooseGroupModal 
                    groups={quizGroups}
                    handleGroup={handleLiveGame}
                    setShowModal={setShowGroupModal}
                />}

                {showLiveGameRoom && 
                <LiveGameRoom 
                    liveGroupId={groupId}
                    groupName={groupName}
                    setShowLiveGameRoom={setShowLiveGameRoom}
                    liveGroupMembers={liveGroupMembers}
                />}
            </Card.Body>
        </Card>
    );
});

export default LiveGameBtn